enum ResponsibilityTypeCode {
  ASC = 'ASC',
  DEALER = 'DEALER',
  SHARED = 'SHARED',
}

export default ResponsibilityTypeCode;
export type VerifyResponsibilityTypeCode = Utils.VerifyExtends<
  Model.Enum.ResponsibilityTypeCode,
  Utils.ValueOf<typeof ResponsibilityTypeCode>
>;
